export default "__VITE_ASSET__53ac80ed__"